import React from "react";
import { Button, Tag } from "antd";
import './history-abon.css';
import './history-debet.css';

const HistoryDebet = ({...props}) => {
    const {debet, services, canPay, onSelect, onPay, needAutopay} = props;
    const selected = true

    const classes = "history-abon-title " + (selected && "history-abon-title-selected");
    if (!debet || debet === 0) return <></>

    const divItems = selected && <div className="history-abon-body">{services.map(item => <div className="history-abon-item" key={item.idDoc}>
        <div>{item.tovName} <Tag>{item.syma} ₽</Tag></div>
        </div>)}
        {canPay ? <div><Button onClick={onPay}>Оплатить</Button></div> : <div>Оплата невозможна - обратитесь к администратору</div>}
    </div>

    return <div className="history-abon-card" onClick={() => onSelect(null)}>
        <div className={classes}>Долг {debet} ₽ {needAutopay ? "[Подписка]" : ""}</div>
        {divItems}
    </div>}

export default HistoryDebet;